<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :items-per-page="20"
    v-bind="$attrs"
  >
    <template #[`item.default_translation.title`]="{ item }">
      <inertia-link
        :href="route('faq.question.edit', [faqId, item.id])"
      >
        {{ item.default_translation.title }}
      </inertia-link>
    </template>
  </v-data-table>
</template>

<script>
export default {
  props: {
    faqId: {
      type: Number,
      required: true
    },
    questions: {
      type: Array,
      required: true
    },
    teamUsersCount: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      headers: this.getHeaders(),
      items: this.questions
    }
  },

  methods: {
    getHeaders() {
      const headers = [
        { text: this.$t('Question title'), value: 'default_translation.title' },
        { text: this.$t('Category'), value: 'category.default_translation.name' },
        { text: this.$t('Subcategory'), value: 'subcategory.default_translation.name' },
        { text: this.$t('Created at'), value: 'created_at' }
      ];

      if (this.teamUsersCount > 0) {
        headers.push({
          text: this.$t('Created by'),
          value: 'created_by'
        });

        headers.push({
          text: this.$t('Last modified at'),
          value: 'last_modified_at'
        })

        headers.push({
          text: this.$t('Last modified by'),
          value: 'last_modified_by'
        });
      }

      return headers;
    },
  }
}
</script>

<style>
.v-data-table {
  white-space: nowrap !important;
}
</style>